export const CHAT_AUTH_HEADER = 'chat-authorization';
